(function () {
  const loadMoreButtons = document.querySelectorAll('[data-single-feedback-load-more]');

  loadMoreButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const reviews = button.closest('.page-width')?.querySelectorAll('.single-feedback__review--extra');

      reviews?.forEach((review) => {
        review.hidden = false;
      });

      button.hidden = true;
    });
  });
})();
